export default __webpack_public_path__ + "static/media/Ballroll_00179.76aac5eb.png";